import { motion } from 'framer-motion';

const services = [
  {
    title: "Design & Graphisme",
    price: "15,00 €",
    rating: "5.0",
    reviews: "854",
    image: "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1",
    link: "https://comeup.com/fr/@tmedia"
  },
  {
    title: "SEO & Communication",
    price: "50,00 €",
    rating: "5.0",
    reviews: "213",
    image: "https://images.unsplash.com/photo-1677110496860-0c5830125699",
    link: "https://comeup.com/fr/@tmedia"
  },
  {
    title: "Développement Web",
    price: "85,00 €",
    rating: "5.0",
    reviews: "329",
    image: "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1",
    link: "https://comeup.com/fr/@tmedia"
  }
];

const ComeUpSection = () => {
  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-b from-gray-900 to-black">
      {/* Effets de fond */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--neon-orange)_0%,_transparent_100%)] opacity-20" />
        <motion.div
          className="absolute top-20 right-20 w-96 h-96 bg-neon-orange/5 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-20 left-20 w-96 h-96 bg-neon-orange/5 rounded-full blur-3xl"
          animate={{
            scale: [1.2, 1, 1.2],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* En-tête de section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="inline-block mb-8"
          >
            <ComeUpLogo />
          </motion.div>
          
          <h2 className="text-4xl font-bold text-white mb-6">
            Retrouvez nos services sur
            <span className="bg-gradient-to-r from-neon-orange to-white bg-clip-text text-transparent"> ComeUp</span>
          </h2>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto">
            Découvrez notre expertise à travers une sélection de services premium, 
            maintenant disponibles sur la plateforme ComeUp
          </p>
        </motion.div>

        {/* Grille de services */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-neon-orange/20 to-transparent rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              
              <div className="relative bg-white/10 backdrop-blur-sm rounded-xl overflow-hidden">
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent" />
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {service.title}
                  </h3>
                  
                  <div className="flex items-center gap-2 mb-4">
                    <span className="text-neon-orange">★</span>
                    <span className="text-white">{service.rating}</span>
                    <span className="text-gray-300">({service.reviews} avis)</span>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-white">À partir de <span className="text-neon-orange font-semibold">{service.price}</span></span>
                    <motion.a
                      href={service.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="bg-neon-orange text-white px-4 py-2 rounded-full text-sm font-medium"
                    >
                      Voir l'offre
                    </motion.a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Call-to-action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center mt-16"
        >
          <motion.a
            href="https://comeup.com/fr/@tmedia"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-neon-orange to-[#FF4500] text-white px-8 py-4 rounded-full font-semibold text-lg relative overflow-hidden group"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="relative z-10">Voir tous nos services sur ComeUp</span>
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0"
              initial={{ x: "-100%" }}
              whileHover={{ x: "100%" }}
              transition={{ duration: 1 }}
            />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

const ComeUpLogo = () => (
  <svg fill="#000" viewBox="0 0 98 27" width="98" height="27" className="w-32 h-auto fill-current text-white">
    <path d="M0 22.41h97.962V27H0zm83.685-5.062h4.7v-4.86h2.324c4.215 0 7.291-2.115 7.291-6.124v-.049C98 2.55 95.239.337 90.952.337h-7.267v17.01Zm4.7-8.554V4.298h2.203c1.696 0 2.713.778 2.713 2.236v.049c0 1.336-1.017 2.21-2.689 2.21h-2.228ZM74.3 17.663c4.82 0 7.945-2.405 7.945-7.897V.338h-4.771v9.574c0 2.381-1.236 3.499-3.125 3.499-1.89 0-3.124-1.166-3.124-3.62V.336h-4.772v9.55c0 5.322 3.028 7.776 7.848 7.776Zm-22.44-.315h13.76v-4.01h-9.11v-2.697h8.139V6.923H56.51V4.347h8.987V.337H51.86zm-19.678 0h4.602v-9.72l4.312 6.61h.097l4.335-6.66v9.77h4.675V.337h-4.965l-4.045 6.585L37.148.338h-4.966zM22.068 0c4.905 0 8.882 3.99 8.882 8.91s-3.977 8.91-8.882 8.91c-4.905 0-8.88-3.99-8.88-8.91S17.162 0 22.067 0Zm0 4.59a4.313 4.313 0 0 0-4.306 4.32 4.313 4.313 0 0 0 4.306 4.32 4.313 4.313 0 0 0 4.306-4.32 4.313 4.313 0 0 0-4.306-4.32Z"></path>
    <path d="M17.762 8.91c0 4.92-3.976 8.91-8.88 8.91C3.975 17.82 0 13.83 0 8.91S3.976 0 8.881 0v4.59a4.313 4.313 0 0 0-4.306 4.32 4.313 4.313 0 0 0 4.306 4.32 4.313 4.313 0 0 0 4.306-4.32Z"></path>
  </svg>
);

export default ComeUpSection;